import axios from '../utils/axios';

export default function assignJob(adminId, data) {
    return (
        axios.post('/admin/' + adminId + '/credits', data)
    )
}
